export const WarningCircleIcon = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2884_3029)">
      <path d="M6.41675 9.24984H7.58342V10.4165H6.41675V9.24984ZM6.41675 4.58317H7.58342V8.08317H6.41675V4.58317ZM6.99425 1.6665C3.77425 1.6665 1.16675 4.27984 1.16675 7.49984C1.16675 10.7198 3.77425 13.3332 6.99425 13.3332C10.2201 13.3332 12.8334 10.7198 12.8334 7.49984C12.8334 4.27984 10.2201 1.6665 6.99425 1.6665ZM7.00008 12.1665C4.42175 12.1665 2.33341 10.0782 2.33341 7.49984C2.33341 4.9215 4.42175 2.83317 7.00008 2.83317C9.57842 2.83317 11.6667 4.9215 11.6667 7.49984C11.6667 10.0782 9.57842 12.1665 7.00008 12.1665Z" />
    </g>
    <defs>
      <clipPath id="clip0_2884_3029">
        <rect
          width="14"
          height="14"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
